import { useMutation } from '@tanstack/react-query';
import { useDialogs, useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Card,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from '@mui/material';
import Button from '@mui/material/Button';

import Api from '@barboxx/api';
import { ProductSubtype } from '@barboxx/models';

interface Props {
    productSubtype: ProductSubtype.DetailsResponse;
}

export const ProductSubtypeDeleteCard = ({ productSubtype }: Props) => {
    const notifications = useNotifications();
    const navigate = useNavigate();
    const dialog = useDialogs();

    const mutateDeleteAlcohol = useMutation({
        mutationKey: ['deleteProductSubtype', productSubtype.id],
        mutationFn: () =>
            Api.Products.Subtypes.deleteProductSubtype(productSubtype),
    });

    const onDelete = async () => {
        const deleteConfirmed = await dialog.confirm(
            'Are you sure you want to Delete this Alcohol Type!',
            {
                severity: 'error',
                okText: 'Delete',
                title: 'Delete Alcohol type',
            }
        );

        if (!deleteConfirmed) {
            return;
        }

        mutateDeleteAlcohol
            .mutateAsync()
            .then(({ data }) => {
                notifications.show('Deleted product subtype!', {
                    severity: 'success',
                });
                navigate('/products/subtypes');
            })
            .catch(e => {
                notifications.show('Error Deleting product subtype!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete Alcohol Subtype" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this product subtype?
                    </Typography>

                    <Button onClick={onDelete} color="error" variant="outlined">
                        Delete
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};
